<template>
  <QuestionnaireBase :title="title" :form="form" :finishFunction="null">
    <template v-slot:default>
      <component :is="show" :key="1" :ref="show" v-model="form"/>
      <component
          v-if="load in $options.components"
          v-show="false"
          :is="load"
          key="load"
          :ref="load"
          v-model="form"
      />
    </template>
  </QuestionnaireBase>
</template>

<script>
import {loadHelpers} from "@/views/questionnaires/loadHelpers";

import QuestionnaireBase from "@/components/common/questionnaires/questionnaire";
import AppendixClientPeople from "@/components/common/questionnaires/fieldsets/appendix/AppendixClientPeople";
import AppendixClientPolicies from "@/components/common/questionnaires/fieldsets/appendix/AppendixClientPolicies";
import AppendixClientAssets from "@/components/common/questionnaires/fieldsets/appendix/AppendixClientAssets";

export default {
  name: "EstatePlanningAppendix",
  mixins: [loadHelpers],
  components: {
    QuestionnaireBase,
    AppendixClientPeople,
    AppendixClientAssets,
    AppendixClientPolicies
  },
  data() {
    return {
      name: 'EstatePlanningAppendix',
      title: "Will Appendix Information",
      url: 'estate_planning_appendix',
      order: [ // imported components required here to load
          'AppendixClientPeople',
          'AppendixClientAssets',
          'AppendixClientPolicies'
      ],
      expiryAccessCodeOnFinish: true
    };
  }
};
</script>
